export default {
    downtimeUrl: "https://it.kodland.tech",
    startPage: {
      title:
        "Zamiast grać w gry i oglądać YouTube'a, nasze dzieci uczą się programowania! 🔥",
      subtitle:
        "<b>Zajęcia są prowadzone w języku polskim! </b>Zapisz się teraz na bezpłatną lekcję ⬇️",
      button: "Odbierz darmową lekcję",
      image: {
        url:  "/welcome/quiz_poland_free_class_pk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      imageMobile: {
        url: "/welcome/quiz_poland_free_class_mobile.png",
        style: {
          width: "100%",
        },
      },
    },
    successPage: {
        title:
          "Drogi Rodzicu!",
        subtitle: 'Dla dziecka w Państwa wieku przygotowaliśmy specjalną ofertę - nauczyciel ze szkoły przeprowadzi indywidualne zajęcia, na których cała uwaga i czas będzie poświęcony',
        button: "📆Dostępne terminy ➡️",
    },
    stopPage: {
        image: "/welcome/quiz_stop_page.jpg",
        title: "Dziękujemy za zainteresowanie szkołą Kodland! Nasze kursy online są przeznaczone dla dzieci i nastolatków w wieku od 8 do 17 lat <p>Zwracamy uwagę, że nasze kursy wymagają takiego sprzętu jak: klawiatura i myszka. Z tego względu telefony, tablety i urządzenia bez tych narzędzi nie są kompatybilne. Aby być na bieżąco z naszymi nowościami, możesz nas śledzić na Instagramie https://www.instagram.com/kodland.pl/ 💙",
    },
    quizRotateBySteps: {
      1: {
        question: "Jak Twoje dziecko najczęściej spędza czas wolny?",
        answers: [
            "🎨 Na zajęciach artystycznych: rysowanie, muzyka, aktorstwo", 
            "🎮 Gra w gry na telefonie lub na komputerze",
            "😊 Gra w gry planszowe",
            "⛹🏼 Uprawia sport",
            "👨‍👩‍👦 Spędza czas z rodziną",
            "🦀 Ogląda kreskówki",
            "💬 Spędza czas z przyjaciółmi"
        ],
      },
      2: {
        question: "Dlaczego warto zainteresować się nauką programowania?",
        answers: [
            "🎮 Dziecko gra w dużo gier", 
            "😜 Dziecko jest 'uzależnione' od YouTube'a i TikTok'a",
            "👾 Dziecko interesuje się programowaniem",
            "❓ Inne",
        ],
      },
      3: {
        question: "Czy posiadasz komputer stacjonarny/laptopa, z którego Twoje dziecko może skorzystać?",
        answers: [
          "✅ Tak",
          {
            answer: "❌ Nie",
            stopAnswer: true
          },
        ],
      },
    },
  };